export function registerChannelsSeo() {
    Alpine.data('seoLinksTable', () => ({
        tab: 'all',
        expanded: null,
        rows: [],
        init() {
            const raw = this.$el.dataset.linkRows;
            if (raw) { try { this.rows = JSON.parse(raw); } catch (_) { this.rows = []; } }
        },
        get filtered() {
            if (this.tab === 'active')  return this.rows.filter(r => r.status === 'active');
            if (this.tab === 'placing') return this.rows.filter(r => r.status === 'placing');
            if (this.tab === 'stopped') return this.rows.filter(r => r.status === 'stopped');
            return this.rows;
        },
        toggle(i) { this.expanded = this.expanded === i ? null : i; },
        statusLabel(s) { return { active: 'Активна', placing: 'На размещении', stopped: 'Снята', error: 'Ошибка' }[s] || s; },
        exportLinksData() {
            var rows = this.filtered;
            if (!rows.length) return;
            var headers = ['Запрос', 'Донор', 'ИКС', 'Анкор', 'Тип', 'Размещена', 'Страница', 'Статус', '₽/сутки'];
            var csv = headers.join(';') + '\n';
            rows.forEach(function(r) {
                csv += [
                    (r.query || '').replace(/;/g, ','), r.donor || '', r.donor_iks || '',
                    (r.anchor || '').replace(/;/g, ','), r.type || '', r.date || '',
                    r.page_url || '', r.status || '', r.price || ''
                ].join(';') + '\n';
            });
            var blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8' });
            var a = document.createElement('a');
            a.href = URL.createObjectURL(blob);
            a.download = 'seo-links-' + new Date().toISOString().slice(0, 10) + '.csv';
            a.click();
            URL.revokeObjectURL(a.href);
        },
    }));

    Alpine.data('seoChannelWizard', (initialUrl) => ({
        step: 1,
        siteUrl: initialUrl || '',
        city: '',
        step2loading: false,
        step2error: '',
        step2statusText: 'Фёдор анализирует сайт...',
        allChecked: true,
        keywords: [],
        _pollTimer: null,
        _taskId: null,
        conversionVisitorLead: null,
        artemLoading: false,
        artemError: '',
        artemAnswer: '',
        fedorLoading: false,
        fedorError: '',
        fedorAnswer: '',
        step3Loading: false,
        step3Error: '',
        step3NeedAmount: false,

        init() {
            fetch('/api/brief').then(r => (r.ok ? r.json() : null)).then(data => {
                if (data && data.kpi && typeof data.kpi.conversion_visitor_lead === 'number') { this.conversionVisitorLead = data.kpi.conversion_visitor_lead; }
            }).catch(() => {});
        },

        get totalBudget() { return this.keywords.filter(k => k.checked).length * 10 * 30; },
        get totalTrafficPerDay() { const ctr = this.ctrForTargetPos(); return this.keywords.filter(k => k.checked).reduce((sum, k) => sum + (k.freq / 30) * ctr, 0); },
        get totalTrafficPerMonth() { return this.totalTrafficPerDay * 30; },
        get totalLeadsPerMonth() { if (!this.conversionVisitorLead) return null; return this.totalTrafficPerMonth * (this.conversionVisitorLead / 100); },
        ctrForTargetPos() { return 0.15; },
        toggleAll() { const val = this.allChecked; this.keywords.forEach(k => k.checked = val); },
        cancelLoading() { if (this._pollTimer) { clearInterval(this._pollTimer); this._pollTimer = null; } this._taskId = null; this.step2loading = false; this.step = 1; },

        async goToStep2() {
            this.step = 2; this.step2loading = true; this.step2error = ''; this.step2statusText = 'Фёдор анализирует сайт...'; this.keywords = []; this.artemAnswer = ''; this.artemError = '';
            try {
                const resp = await fetch('/api/seo/semantics', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': window.getCsrfToken() }, body: JSON.stringify({ url: this.siteUrl, city: this.city }) });
                const data = await resp.json();
                if (!resp.ok || data.error) { this.step2loading = false; this.step2error = data.error || 'Не удалось создать задачу'; return; }
                this._taskId = data.task_id; this.step2statusText = 'Фёдор подбирает ключевые запросы...'; this._startPolling();
            } catch (e) { this.step2loading = false; this.step2error = 'Ошибка сети: ' + e.message; }
        },

        _startPolling() {
            let attempts = 0;
            const maxAttempts = 60;
            this._pollTimer = setInterval(async () => {
                attempts++;
                if (attempts > maxAttempts) { clearInterval(this._pollTimer); this._pollTimer = null; this.step2loading = false; this.step2error = 'Превышено время ожидания (5 мин). Попробуйте позже.'; return; }
                this.step2statusText = `Фёдор анализирует семантику... (${attempts * 5} сек)`;
                try {
                    const resp = await fetch(`/api/seo/semantics/status?task_id=${this._taskId}`);
                    const data = await resp.json();
                    if (!resp.ok || data.error) { clearInterval(this._pollTimer); this._pollTimer = null; this.step2loading = false; this.step2error = data.error || 'Ошибка проверки статуса'; return; }
                    if (data.ready) {
                        clearInterval(this._pollTimer); this._pollTimer = null;
                        this.keywords = (data.keywords || []).map(kw => ({ phrase: kw.phrase || '', freq: kw.freq || 0, pos: kw.pos || 0, checked: true }));
                        this.allChecked = true; this.step2loading = false;
                    }
                } catch (e) {}
            }, 5000);
        },

        async askArtem() {
            this.artemError = ''; this.artemAnswer = ''; this.artemLoading = true;
            try {
                const selected = this.keywords.filter(k => k.checked).map(k => ({ phrase: k.phrase, ws: k.freq, pos: k.pos }));
                if (selected.length === 0) { this.artemError = 'Выберите хотя бы одну фразу.'; this.artemLoading = false; return; }
                const resp = await fetch('/api/seo/semantics/ask-artem', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': window.getCsrfToken() }, body: JSON.stringify({ keywords: selected }) });
                const data = await resp.json();
                if (!resp.ok || data.error) { this.artemError = data.error || 'Не удалось получить ответ от Артёма'; this.artemAnswer = ''; } else { this.artemAnswer = data.answer || ''; }
            } catch (e) { this.artemError = 'Ошибка сети: ' + e.message; this.artemAnswer = ''; } finally { this.artemLoading = false; }
        },

        async askFedor() {
            this.fedorError = ''; this.fedorAnswer = ''; this.fedorLoading = true;
            try {
                const selected = this.keywords.filter(k => k.checked).map(k => ({ phrase: k.phrase || k.text }));
                if (selected.length === 0) { this.fedorError = 'Выберите хотя бы одну фразу.'; this.fedorLoading = false; return; }
                const resp = await fetch('/api/seo/semantics/ask-fedor', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': window.getCsrfToken() }, body: JSON.stringify({ keywords: selected }) });
                const data = await resp.json();
                if (!resp.ok || data.error) { this.fedorError = data.error || 'Не удалось получить ответ от Фёдора'; this.fedorAnswer = ''; } else { this.fedorAnswer = data.answer || ''; }
            } catch (e) { this.fedorError = 'Ошибка сети: ' + e.message; this.fedorAnswer = ''; } finally { this.fedorLoading = false; }
        },

        async launchSeo() {
            this.step3Error = ''; this.step3NeedAmount = false;
            const selected = this.keywords.filter(k => k.checked).map(k => ({ phrase: k.phrase, url: this.siteUrl || undefined }));
            if (selected.length === 0) { this.step3Error = 'Выберите хотя бы одну ключевую фразу.'; return; }
            this.step3Loading = true;
            try {
                const resp = await fetch('/api/seo/channel/confirm', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': window.getCsrfToken() }, body: JSON.stringify({ url: this.siteUrl, city: this.city, phrases: selected }) });
                const data = await resp.json().catch(() => ({}));
                if (resp.ok && data.success) { window.location.href = data.redirect || '/channels/seo'; return; }
                this.step3Error = data.error || 'Не удалось запустить продвижение. Попробуйте позже.';
                if (data.need_amount != null) this.step3NeedAmount = true;
            } catch (e) { this.step3Error = 'Ошибка сети: ' + (e.message || 'нет связи'); } finally { this.step3Loading = false; }
        },
    }));

}

export function initWebmasterBind() {
    var root = document.querySelector('[data-webmaster-channel-id]');
    var btn = document.querySelector('[data-webmaster-bind]');
    var statusEl = document.getElementById('webmaster-bind-status');
    if (!root || !btn) return;
    var channelId = parseInt(root.getAttribute('data-webmaster-channel-id') || '0', 10);
    var url = root.getAttribute('data-webmaster-channel-url') || '';
    if (!channelId || !url) return;

    btn.addEventListener('click', function () {
        if (statusEl) { statusEl.textContent = 'Проверяем домен в Яндексе…'; statusEl.classList.remove('text-red-600', 'text-emerald-600'); statusEl.classList.add('text-slate-500'); }
        fetch('/api/seo/webmaster/bind-host', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': window.getCsrfToken() }, body: JSON.stringify({ channel_id: channelId, url: url }) })
            .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
            .then(function (r) {
                if (!statusEl) return;
                if (r.ok && r.data && r.data.success) { statusEl.textContent = 'Всё ок: домен найден в Яндекс Вебмастере, привязка сохранена.'; statusEl.classList.remove('text-red-600', 'text-slate-500'); statusEl.classList.add('text-emerald-600'); }
                else { var msg = (r.data && r.data.error) || 'Не удалось привязать сайт'; if (msg === 'no_webmaster_token') { msg = 'Сначала подключите Яндекс Вебмастер через кнопку сверху, затем вернитесь и повторите проверку.'; } else if (msg === 'host_not_found_for_domain') { msg = 'В вашем аккаунте Яндекс Вебмастера не найден этот домен. Добавьте сайт в Вебмастер и попробуйте снова.'; } statusEl.textContent = msg; statusEl.classList.remove('text-emerald-600', 'text-slate-500'); statusEl.classList.add('text-red-600'); }
            })
            .catch(function () { if (!statusEl) return; statusEl.textContent = 'Сетевой запрос не удался. Попробуйте позже.'; statusEl.classList.remove('text-emerald-600', 'text-slate-500'); statusEl.classList.add('text-red-600'); });
    });
}
